var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"text-to-speech-player-simple"},[_c('audio-player-icon',{attrs:{"on-audio-click":_vm.onAudioClick,"is-playing":_vm.isPlaying}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }